import React from 'react';

const DetailedView = ({ familyRow }) => {
  return (
    <>
      {/* Registration Summary */}
      <div style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '2px solid #007bff'
      }}>
        <h5 style={{ color: '#007bff', marginBottom: '20px', fontWeight: '600', textAlign: 'center' }}>
          📋 Registration Summary
        </h5>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', textAlign: 'center' }}>
          <div style={{ padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1976d2' }}>{familyRow.id}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>Registration ID</div>
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f3e5f5', borderRadius: '8px' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#7b1fa2' }}>{Object.keys(familyRow.members || {}).length}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>Total Members</div>
          </div>
          <div style={{ padding: '15px', backgroundColor: '#e8f5e8', borderRadius: '8px' }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#388e3c' }}>
              {familyRow.meta?.status === 'approved' ? '✅ Approved' :
               familyRow.meta?.status === 'hold' ? '⏸ On Hold' :
               familyRow.meta?.status === 'rejected' ? '❌ Rejected' :
               familyRow.meta?.status === 'request_changes' ? '⚠ Changes Requested' : '⏳ Pending'}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>Status</div>
            {/* Display reason for hold/rejected status */}
            {(familyRow.meta?.status === 'hold' && familyRow.meta?.holdReason) && (
              <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffeaa7' }}>
                <strong style={{ color: '#856404', fontSize: '12px' }}>Hold Reason:</strong>
                <div style={{ fontSize: '11px', color: '#856404', marginTop: '2px' }}>{familyRow.meta.holdReason}</div>
              </div>
            )}
            {(familyRow.meta?.status === 'rejected' && familyRow.meta?.rejectionReason) && (
              <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#f8d7da', borderRadius: '4px', border: '1px solid #f5c6cb' }}>
                <strong style={{ color: '#721c24', fontSize: '12px' }}>Rejection Reason:</strong>
                <div style={{ fontSize: '11px', color: '#721c24', marginTop: '2px' }}>{familyRow.meta.rejectionReason}</div>
              </div>
            )}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#fff3e0', borderRadius: '8px' }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#f57c00' }}>
              {familyRow.meta?.createdAt ? new Date(familyRow.meta.createdAt).toLocaleDateString() : '-'}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>Registration Date</div>
          </div>
        </div>
      </div>

      {/* Location Information */}
      <div style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h5 style={{ color: '#333', marginBottom: '20px', fontWeight: '600', borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>
          📍 Location Information
        </h5>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Country:</strong> {familyRow.basic?.country || 'India'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>State:</strong> {familyRow.basic?.state || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>City:</strong> {familyRow.basic?.city || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Block:</strong> {familyRow.basic?.block || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Area Type:</strong> {familyRow.basic?.areaType || '-'}
          </div>
          {familyRow.basic?.areaType === 'Rural' && familyRow.basic?.panchayat && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>Panchayat:</strong> {familyRow.basic.panchayat}
            </div>
          )}
          {familyRow.basic?.areaType === 'Urban' && familyRow.basic?.urbanArea && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>Urban Area:</strong> {familyRow.basic.urbanArea}
            </div>
          )}
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6', gridColumn: 'span 2' }}>
            <strong style={{ color: '#007bff' }}>Full Address:</strong><br/>
            {familyRow.basic?.address || '-'}
          </div>
        </div>
      </div>

      {/* Family Information */}
      <div style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h5 style={{ color: '#333', marginBottom: '20px', fontWeight: '600', borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>
          👨👩👧👦 Family Information
        </h5>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Head of Family:</strong> {familyRow.basic?.headName || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Popular Name:</strong> {familyRow.basic?.displayName || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Mobile:</strong> {familyRow.basic?.mobile || familyRow.meta?.contactNumber || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Total Members:</strong> {familyRow.basic?.Totalmember || Object.keys(familyRow.members || {}).length || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Mother Tongue:</strong> {familyRow.basic?.language || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Family Type:</strong> {familyRow.basic?.familyType || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>House Type:</strong> {familyRow.basic?.houseType || '-'}
          </div>
          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <strong style={{ color: '#007bff' }}>Jain Temple:</strong> {familyRow.basic?.Mandirtype || '-'}
          </div>
          {familyRow.basic?.mandirRelation && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>Temple Relation:</strong> {familyRow.basic.mandirRelation}
            </div>
          )}
          {familyRow.basic?.jatiPrakar && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>जाति प्रकार:</strong> {familyRow.basic.jatiPrakar}
            </div>
          )}
          {familyRow.basic?.upjatiPrakar && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>उपजाति प्रकार:</strong> {familyRow.basic.upjatiPrakar}
            </div>
          )}
          {familyRow.basic?.gotra && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>गोत्र:</strong> {familyRow.basic.gotra}
            </div>
          )}
          {familyRow.basic?.moor && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <strong style={{ color: '#007bff' }}>मूर:</strong> {familyRow.basic.moor}
            </div>
          )}
          <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
            <strong style={{ color: '#856404' }}>Password:</strong> {familyRow.meta?.password || '-'}
          </div>
        </div>
      </div>

      {/* Members Details */}
      <div style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h5 style={{ color: '#333', marginBottom: '20px', fontWeight: '600', borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>
          👥 Family Members ({Object.keys(familyRow.members || {}).length})
        </h5>
        {Object.keys(familyRow.members || {}).length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            No members added yet
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '20px' }}>
            {Object.entries(familyRow.members || {}).map(([mk, mv], idx) => (
              <div key={mk} style={{
                padding: '20px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                position: 'relative'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  right: '15px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  padding: '5px 10px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  Member #{idx + 1} | ID: {mv.memberId || '-'}
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', marginTop: '20px' }}>
                  <div>
                    <strong style={{ color: '#007bff' }}>Name:</strong><br/>
                    <span style={{ fontSize: '16px', fontWeight: '500' }}>{mv.name || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Father/Husband:</strong><br/>
                    <span>{mv.fatherName || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Gender:</strong><br/>
                    <span>{mv.gender || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Relation:</strong><br/>
                    <span>{mv.relation || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Date of Birth:</strong><br/>
                    <span>{mv.dob || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Aadhaar:</strong><br/>
                    <span>{mv.aadhaar || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Mobile:</strong><br/>
                    <span>{mv.mobile || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>WhatsApp:</strong><br/>
                    <span>{mv.whatsapp || '-'}</span>
                  </div>
                  <div>
                    <strong style={{ color: '#007bff' }}>Email:</strong><br/>
                    <span>{mv.email || '-'}</span>
                  </div>
                  {mv.bloodGroup && (
                    <div>
                      <strong style={{ color: '#007bff' }}>Blood Group:</strong><br/>
                      <span>{mv.bloodGroup}</span>
                    </div>
                  )}
                  {mv.maritalStatus && (
                    <div>
                      <strong style={{ color: '#007bff' }}>Marital Status:</strong><br/>
                      <span>{mv.maritalStatus}</span>
                    </div>
                  )}
                  {mv.currentAddress && (
                    <div style={{ gridColumn: 'span 3' }}>
                      <strong style={{ color: '#007bff' }}>Current Address:</strong><br/>
                      <span>{mv.currentAddress}</span>
                    </div>
                  )}
                  {mv.birthAddress && (
                    <div style={{ gridColumn: 'span 3' }}>
                      <strong style={{ color: '#007bff' }}>Birth Address:</strong><br/>
                      <span>{mv.birthAddress}</span>
                    </div>
                  )}
                </div>
                
                {/* Education/Work Details */}
                {(mv.educationStatus || mv.workType || mv.educationState || mv.workState) && (
                  <div style={{ marginTop: '20px', padding: '15px', backgroundColor: 'white', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                    <strong style={{ color: '#28a745', marginBottom: '10px', display: 'block' }}>📚 Education/Work Details:</strong>
                    
                    {/* Education Information */}
                    {(mv.educationStatus || mv.educationState || mv.educationDistrict || mv.educationClass || mv.educationSubject) && (
                      <div style={{ marginBottom: '15px' }}>
                        <h6 style={{ color: '#007bff', marginBottom: '10px' }}>शिक्षा की जानकारी:</h6>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                          {mv.educationStatus && (
                            <div>
                              <strong>शिक्षा की स्थिति:</strong><br/>
                              <span>{mv.educationStatus}</span>
                            </div>
                          )}
                          {mv.educationState && (
                            <div>
                              <strong>राज्य:</strong><br/>
                              <span>{mv.educationState}</span>
                            </div>
                          )}
                          {mv.educationDistrict && (
                            <div>
                              <strong>जिला:</strong><br/>
                              <span>{mv.educationDistrict}</span>
                            </div>
                          )}
                          {mv.educationClass && (
                            <div>
                              <strong>कक्षा:</strong><br/>
                              <span>{mv.educationClass}</span>
                            </div>
                          )}
                          {mv.educationSubject && (
                            <div>
                              <strong>विषय:</strong><br/>
                              <span>{mv.educationSubject}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {/* Work Information */}
                    {(mv.workType || mv.workState || mv.workDistrict || mv.workArea || mv.workAreaName || mv.workDepartment || mv.workPosition) && (
                      <div>
                        <h6 style={{ color: '#007bff', marginBottom: '10px' }}>कार्य की जानकारी:</h6>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                          {mv.workType && (
                            <div>
                              <strong>कार्य का प्रकार:</strong><br/>
                              <span>{mv.workType}</span>
                            </div>
                          )}
                          {mv.workState && (
                            <div>
                              <strong>राज्य:</strong><br/>
                              <span>{mv.workState}</span>
                            </div>
                          )}
                          {mv.workDistrict && (
                            <div>
                              <strong>जिला:</strong><br/>
                              <span>{mv.workDistrict}</span>
                            </div>
                          )}
                          {mv.workArea && (
                            <div>
                              <strong>क्षेत्र:</strong><br/>
                              <span>{mv.workArea}</span>
                            </div>
                          )}
                          {mv.workAreaName && (
                            <div>
                              <strong>कार्य क्षेत्र का नाम:</strong><br/>
                              <span>{mv.workAreaName}</span>
                            </div>
                          )}
                          {mv.workDepartment && (
                            <div>
                              <strong>विभाग/प्रकार:</strong><br/>
                              <span>{mv.workDepartment}</span>
                            </div>
                          )}
                          {mv.workPosition && (
                            <div>
                              <strong>पद/नाम:</strong><br/>
                              <span>{mv.workPosition}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {/* Jain Information */}
                    {(mv.jatiPrakar || mv.upjatiPrakar || mv.gotra || mv.moor) && (
                      <div style={{ marginTop: '15px' }}>
                        <h6 style={{ color: '#007bff', marginBottom: '10px' }}>🕊️ जैन जाति की जानकारी:</h6>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                          {mv.jatiPrakar && (
                            <div>
                              <strong>जाति प्रकार:</strong><br/>
                              <span>{mv.jatiPrakar}</span>
                            </div>
                          )}
                          {mv.upjatiPrakar && (
                            <div>
                              <strong>उपजाति प्रकार:</strong><br/>
                              <span>{mv.upjatiPrakar}</span>
                            </div>
                          )}
                          {mv.gotra && (
                            <div>
                              <strong>गोत्र:</strong><br/>
                              <span>{mv.gotra}</span>
                            </div>
                          )}
                          {mv.moor && (
                            <div>
                              <strong>मूर:</strong><br/>
                              <span>{mv.moor}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default DetailedView;